import { render, staticRenderFns } from "./MenuLoader.vue?vue&type=template&id=e5e3a46c&scoped=true&"
import script from "./MenuLoader.vue?vue&type=script&lang=js&"
export * from "./MenuLoader.vue?vue&type=script&lang=js&"
import style0 from "./MenuLoader.vue?vue&type=style&index=0&id=e5e3a46c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e3a46c",
  null
  
)

export default component.exports